module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n8r3n6n-1111a73845f9a1a8c1b1a1934da88b27.svg";